import { render, staticRenderFns } from "./colour-picker.vue?vue&type=template&id=1f1996d2"
import script from "./colour-picker.vue?vue&type=script&lang=js"
export * from "./colour-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports